module.exports = __webpack_public_path__ + "static/media/beep.e43e76d7.mp3";